import React, { useContext, useEffect, useState } from "react";
import Contexto from "../context/Contexto";
import parse from "react-html-parser";

const WinterHackDescuentos = () => {
  const {
    usuario,
    influencers,
    loguearUsuario,
    desconectarUsuario,
    cursoscomprados,
    cambiaPrecio,
  } = useContext(Contexto);
  const [precioFinal, setPrecioFinal] = useState(35000);
  const [mensaje, setMensaje] = useState("");
  const [descuentardo, setDescuentardo] = useState("");
  const [influ, setInflu] = useState("");
  const [textito, setTextito] = useState("");

  useEffect(() => {
    calcularDescuento();
  }, [cursoscomprados]);
  const calcularDescuento = () => {
    let descuento = 0;
    let txt = "";
    if (cursoscomprados.html) {
      if (cursoscomprados.html.estado && cursoscomprados.html.restantes > 90) {
        descuento = descuento + 3500;
        txt = txt + "/ html";
      }
    }
    if (cursoscomprados.js) {
      if (cursoscomprados.js.estado && cursoscomprados.js.restantes > 90) {
        descuento = descuento + 3500;
        txt = txt + "/ js";
      }
    }
    if (cursoscomprados.react) {
      if (
        cursoscomprados.react.estado &&
        cursoscomprados.react.restantes > 90
      ) {
        descuento = descuento + 3500;
        txt = txt + "/ react";
      }
    }
    if (cursoscomprados.firebase) {
      if (
        cursoscomprados.firebase.estado &&
        cursoscomprados.firebase.restantes > 90
      ) {
        descuento = descuento + 3500;
        txt = txt + " / firebase";
      }
    }
    setPrecioFinal(35000 - descuento);
    setMensaje(
      `Por tener ${txt} </br><strong>te descontamos AR$ ${descuento}</strong>`
    );
  };
  const handleChange = (e) => {
    setTextito(e.target.value);
  };
  const codigo = document.getElementById("Descuento");
  const handleClick = () => {
    let descuentardi = textito;
    codigo.value = "";

    if (!influencers.includes(descuentardi)) {
      setDescuentardo("Codigo de comunidad incorrecto");
    } else if (precioFinal !== 35000) {
      setDescuentardo(
        "Ya tenes un descuento de cursos, no podes aplicar de comunid :("
      );
    }
    // if (influencers.includes(descuentardi) && precioFinal === 35000) {
    //   setPrecioFinal(16000);
    //   setInflu(descuentardi);
    //   setMensaje(
    //     `Por ser parte de la comunidad de ${descuentardi} te descontamos AR$ 4000 (20%OFF)`
    //   );
    // } else {
    // }
  };

  let comprarlo = () => {
    cambiaPrecio("/summerhack23", precioFinal);
  };
  return (
    <>
      <div className="comboOferta">
        {precioFinal != 35000 ? (
          <>
            <h4 className="precioViejo">
              <del>AR$ 35.000</del>
            </h4>
            <h1 className="precioFinal">AR$ {precioFinal}</h1>

            <p>{parse(mensaje)}</p>
          </>
        ) : (
          <>
            <h1>AR$ 35.000</h1>
          </>
        )}

        <p>
          Precio completo por los 3 meses <br></br>{" "}
          <strong>Pagalos hasta en 3 cuotas sin interés</strong>
        </p>

        {usuario !== null ? (
          <>
            <button
              className="btn btn-primary"
              onClick={() => {
                comprarlo();
              }}
            >
              COMPRAR
            </button>{" "}
            <br /> <br />
            <button
              className="btn btn-outline-secondary"
              onClick={() => {
                desconectarUsuario();
              }}
            >
              Desconectame
            </button>
            <div class="row g-6 centradoFlex">
              <div class="col-auto">
                <input
                  type="text"
                  class="form-control"
                  id="Descuento"
                  placeholder="Tengo un descuentx"
                  onChange={handleChange}
                />
              </div>
              <div class="col-auto">
                <button
                  type="submit"
                  class="btn btn-primary mb-3"
                  onClick={handleClick}
                >
                  Aplicar descuento
                </button>
              </div>
              <p className="blanco">{descuentardo}</p>
            </div>
          </>
        ) : (
          <>
            <p>
              Logueate con tu usuario para poder sumarte al programa. Si ya
              tenés alguno de los cursos incluidos, vas a ver un descuento en el
              precio final por cada uno.
            </p>
            <button
              className="SHbtnComprar"
              onClick={() => {
                loguearUsuario();
              }}
            >
              LOGUEAME Y DESCONTAME!
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default WinterHackDescuentos;
